import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Units } from '@utils/type-cases';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class RolesPermisosService {
  constructor(public http: HttpClient, private env: EnvService) { }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  crear(body): Observable<any> {
    return this.http.post(`${this.env.URL_API}/rol_permiso`, body);
  }
  actualizar(body): Observable<any> {
    return this.http.put(
      `${this.env.URL_API}/rol_permiso/${body.id_roles}`,
      body
    );
  }
  obtenerTodos(): Observable<any> {
    return this.http.get(`${this.env.URL_API}/rol_permiso`, {
      headers: this.headers,
    });
  }
  obtenerId(id): Observable<any> {
    return this.http.get(`${this.env.URL_API}/rol_permiso/${id}`);
  }
  eliminar(id): Observable<any> {
    return this.http.delete(`${this.env.URL_API}/rol_permiso/${id}`);
  }
  byModule(module): Observable<any> {
    return this.http.get(
      `${this.env.URL_API}/rol_permisos/byModule/${module}`
    );
  }
  takeUser(permiso): Observable<any> {
    return this.http.post(`${this.env.URL_API}/rol_permiso/takeUser`, permiso);
  }
}
